import { TranslationDictionary } from "../../shared/Language";
import { PropertyDictionary } from "./PropertyDictionary";
import { UiDictionary } from "./UiDictionary";
import { InvestmentStepsDictionary } from "./InvestmentStepsDictionary";
import { ProjectDictionary } from "./ProjectDictionary";

const dictionary: TranslationDictionary = { ...PropertyDictionary, ...UiDictionary, ...InvestmentStepsDictionary, ...ProjectDictionary }

export default dictionary